import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const SalesLineChart = ({ endpoint }) => {

  let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"


  const [rawData, setRawData] = useState([]);
  const [chartData, setChartData] = useState([]);

  const todayDate = new Date().toISOString().split("T")[0]; // "2025-07-14"

  const fetchLineChartData = async () => {
    try {
      const response = await axios.get(
        `https://cubixweberp.com:213/api/HRDashboard/${company_code_from_local_storage}/MAIN/${endpoint}/2024-01-01/${todayDate}/-/-/-/-/-`
      );
      const data = response.data;
      setRawData(data);

      // Step 1: Extract month keys (e.g., '2025-07') from the first record
      const monthKeys = Object.keys(data[0] || {}).filter((key) =>
        /^\d{4}-\d{2}$/.test(key)
      );

      // Step 2: Sort months chronologically
      const sortedMonths = monthKeys.sort();

      // Step 3: Build chart data: one object per month
      const formattedChartData = sortedMonths.map((month) => {
        const entry = { month };
        data.forEach((salesman) => {
          entry[salesman.sman_name?.trim()] = salesman[month] || 0;
        });
        return entry;
      });

      setChartData(formattedChartData);
    } catch (error) {
      console.error("Error fetching chart data:", error);
    }
  };

  useEffect(() => {
    fetchLineChartData();
  }, [endpoint]);

  const colors = [
    "#3B82F6", "#A855F7", "#EAB308", "#EF4444", "#22C55E", "#06B6D4", "#F97316",
  ];

  return (
    <div className="w-full h-[400px]">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData} margin={{ top: 20, right: 30, left: 10, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip />
          <Legend />
          {rawData.map((salesman, index) => (
            <Line
              key={salesman.sman_key}
              type="monotone"
              dataKey={salesman.sman_name?.trim()}
              stroke={colors[index % colors.length]}
              strokeWidth={2}
              dot={{ r: 2 }}
              activeDot={{ r: 5 }}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SalesLineChart;